import React, { Children } from 'react';
import { CodeIcon, LayersIcon, PenToolIcon, DatabaseIcon, ShieldIcon, ServerIcon, MonitorIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Skills() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const barVariants = {
    hidden: {
      width: 0
    },
    visible: width => ({
      width: `${width}%`,
      transition: {
        duration: 1,
        ease: 'easeOut'
      }
    })
  };
  return <section id="skills" className="py-20 px-4" data-id="element-202">
      <div className="container mx-auto max-w-5xl" data-id="element-203">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-205">
            Skills & Expertise
          </h2>
          <div className="w-20 h-1 bg-purple-600 mx-auto" data-id="element-206"></div>
        </motion.div>
        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-207">
          <motion.div className="bg-white p-8 rounded-lg shadow-md text-center" variants={cardVariants} whileHover={{
          y: -10,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
        }} data-id="element-208">
            <div className="inline-block p-4 bg-purple-100 rounded-full mb-4" data-id="element-209">
              <ServerIcon size={32} className="text-purple-600" data-id="element-210" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-211">
              Networking
            </h3>
            <p className="text-gray-600" data-id="element-212">
              LAN/WAN, TCP/IP, Routing, Switching, VPN, Firewalls
            </p>
          </motion.div>
          <motion.div className="bg-white p-8 rounded-lg shadow-md text-center" variants={cardVariants} whileHover={{
          y: -10,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
        }} data-id="element-213">
            <div className="inline-block p-4 bg-purple-100 rounded-full mb-4" data-id="element-214">
              <ShieldIcon size={32} className="text-purple-600" data-id="element-215" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-216">
              Cybersecurity
            </h3>
            <p className="text-gray-600" data-id="element-217">
              Threat Detection, Penetration Testing, Security Audits
            </p>
          </motion.div>
          <motion.div className="bg-white p-8 rounded-lg shadow-md text-center" variants={cardVariants} whileHover={{
          y: -10,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
        }} data-id="element-218">
            <div className="inline-block p-4 bg-purple-100 rounded-full mb-4" data-id="element-219">
              <MonitorIcon size={32} className="text-purple-600" data-id="element-220" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-221">
              Operating Systems
            </h3>
            <p className="text-gray-600" data-id="element-222">
              Windows, Linux, macOS, Server Administration
            </p>
          </motion.div>
          <motion.div className="bg-white p-8 rounded-lg shadow-md text-center" variants={cardVariants} whileHover={{
          y: -10,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
        }} data-id="element-223">
            <div className="inline-block p-4 bg-purple-100 rounded-full mb-4" data-id="element-224">
              <LayersIcon size={32} className="text-purple-600" data-id="element-225" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-226">
              PC Troubleshooting
            </h3>
            <p className="text-gray-600" data-id="element-227">
              Hardware Diagnostics, Software Repair, System Recovery
            </p>
          </motion.div>
        </motion.div>
        <motion.div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6" initial="hidden" whileInView="visible" viewport={{
        once: true
      }} transition={{
        staggerChildren: 0.1,
        delayChildren: 0.3
      }} data-id="element-228">
          <div className="skill-bar" data-id="element-229">
            <div className="flex justify-between mb-1" data-id="element-230">
              <span className="text-gray-700 font-medium" data-id="element-231">
                Network Security
              </span>
              <span className="text-gray-600" data-id="element-232">95%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-233">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={95} variants={barVariants} data-id="element-234"></motion.div>
            </div>
          </div>
          <div className="skill-bar" data-id="element-235">
            <div className="flex justify-between mb-1" data-id="element-236">
              <span className="text-gray-700 font-medium" data-id="element-237">Cybersecurity</span>
              <span className="text-gray-600" data-id="element-238">90%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-239">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={90} variants={barVariants} data-id="element-240"></motion.div>
            </div>
          </div>
          <div className="skill-bar" data-id="element-241">
            <div className="flex justify-between mb-1" data-id="element-242">
              <span className="text-gray-700 font-medium" data-id="element-243">Windows OS</span>
              <span className="text-gray-600" data-id="element-244">85%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-245">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={85} variants={barVariants} data-id="element-246"></motion.div>
            </div>
          </div>
          <div className="skill-bar" data-id="element-247">
            <div className="flex justify-between mb-1" data-id="element-248">
              <span className="text-gray-700 font-medium" data-id="element-249">Linux</span>
              <span className="text-gray-600" data-id="element-250">80%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-251">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={80} variants={barVariants} data-id="element-252"></motion.div>
            </div>
          </div>
          <div className="skill-bar" data-id="element-253">
            <div className="flex justify-between mb-1" data-id="element-254">
              <span className="text-gray-700 font-medium" data-id="element-255">
                PC Troubleshooting
              </span>
              <span className="text-gray-600" data-id="element-256">95%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-257">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={95} variants={barVariants} data-id="element-258"></motion.div>
            </div>
          </div>
          <div className="skill-bar" data-id="element-259">
            <div className="flex justify-between mb-1" data-id="element-260">
              <span className="text-gray-700 font-medium" data-id="element-261">
                Firewall Configuration
              </span>
              <span className="text-gray-600" data-id="element-262">85%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-263">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={85} variants={barVariants} data-id="element-264"></motion.div>
            </div>
          </div>
          <div className="skill-bar" data-id="element-265">
            <div className="flex justify-between mb-1" data-id="element-266">
              <span className="text-gray-700 font-medium" data-id="element-267">
                Server Management
              </span>
              <span className="text-gray-600" data-id="element-268">80%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-269">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={80} variants={barVariants} data-id="element-270"></motion.div>
            </div>
          </div>
          <div className="skill-bar" data-id="element-271">
            <div className="flex justify-between mb-1" data-id="element-272">
              <span className="text-gray-700 font-medium" data-id="element-273">
                Vulnerability Assessment
              </span>
              <span className="text-gray-600" data-id="element-274">85%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-275">
              <motion.div className="bg-purple-600 h-2.5 rounded-full" custom={85} variants={barVariants} data-id="element-276"></motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}